<template>
  <b-dropdown
    size="lg"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    class="dgViewSelector"
  >
    <template v-slot:button-content>
      <icon name="chevron-down" />
    </template>
    <b-dropdown-item
      href="#"
      v-for="(name, key) in views"
      :key="key"
      class="dgViewSelector__item"
      @click="setView(key)"
    >
      <icon name="circle" v-if="isSelected(key)" scale=".5" />
      <span>{{ name }}</span>
      <b-button
        variant="danger"
        size="sm"
        v-if="key !== 'default'"
        class="dgViewSelector__itemRemove"
        @click.stop="remove(key)"
      >
        <icon name="remove" />
      </b-button>
    </b-dropdown-item>
    <b-dropdown-item href="#" @click="create">
      <icon name="plus" />
      <span>Create view</span>
    </b-dropdown-item>
    <CreateViewModal ref="createViewModal" :inherited="inherited" />
  </b-dropdown>
</template>

<script>
import { mapState } from 'vuex'
// components
import CreateViewModal from '../modals/CreateView'
// services
import db from '@/services/db'

export default {
  name: 'DataGrid_createView',
  props: ['gridId', 'view', 'widgetKey', 'inherited'],
  components: {
    CreateViewModal,
  },
  computed: {
    ...mapState(['dataGrid_options']),
    views() {
      const viewsReady = { default: 'Default' }
      const views = this.dataGrid_options[this.gridId].views

      if (!views) return viewsReady

      for (let viewKey in views) {
        viewsReady[viewKey] = views[viewKey].title
      }

      return viewsReady
    },
  },
  methods: {
    isSelected(key) {
      if (!this.view && key === 'default') return true
      if (key === 'default' && this.view && !this.views[this.view]) return true
      else if (this.view === key) return true
      return false
    },
    create() {
      this.$refs.createViewModal.open()
    },
    setView(viewKey) {
      if (viewKey === 'default')
        db.dataGrid.options.setView(this.widgetKey, null)
      else db.dataGrid.options.setView(this.widgetKey, viewKey)
    },
    remove(viewKey) {
      const data = {
        gridId: this.gridId,
        viewKey,
      }

      db.dataGrid.options.removeView(data)
    },
  },
}
</script>

<style lang="scss">
.dgViewSelector {
  svg {
    color: #5e72e4;
  }
  .dropdown-toggle {
    padding: 0;
    svg {
      vertical-align: 0;
    }
  }
  &__item {
    position: relative;
    svg {
      vertical-align: 0px !important;
      margin: {
        left: 3px;
        right: 18px !important;
      }
    }
  }
  &__itemRemove {
    position: absolute;
    right: 10px;
    width: 20px;
    height: 20px;
    padding: 0;
    padding-top: 1px;
    svg {
      color: white;
    }
  }
}
</style>
